(() => {
  const exactReplacements = new Map([
    ["Cookie consent", "Gestion des cookies"],
    ["Manage preferences", "Gérer mes préférences"],
    ["Accept", "Accepter"],
    ["Decline", "Refuser"],
    ["Privacy Policy", "Politique de confidentialité"],
    ["Skip to content", "Aller au contenu"],
    ["Cart", "Panier"],
    ["Your cart is empty", "Votre panier est vide"],
    ["Have an account? Log in to check out faster.", "Vous avez un compte ? Connectez-vous pour commander plus rapidement."],
    ["Discount", "Remise"],
    ["Estimated total", "Total estimé"],
    ["Product image", "Image du produit"],
    ["Product information", "Informations produit"],
    ["Product total", "Total produit"],
    ["Price", "Prix"],
    ["Decrease quantity", "Diminuer la quantité"],
    ["Increase quantity", "Augmenter la quantité"],
    ["Remove", "Retirer"],
    ["You may also like", "Vous pourriez aussi aimer"],
    ["View all", "Voir tout"],
  ]);

  const phraseReplacements = [
    [
      "We and our partners, including Shopify, use cookies and other technologies to personalize your experience, show you ads, and perform analytics, and we will not use cookies or other technologies for these purposes unless you accept them. Learn more in our Privacy Policy",
      "Nous utilisons des cookies pour améliorer votre expérience, personnaliser le contenu et réaliser des statistiques. Vous pouvez accepter, refuser ou gérer vos préférences."
    ],
    ["Total items in cart", "Articles dans le panier"],
    [
      "Duties and taxes included. Shipping is calculated at checkout.",
      "Taxes incluses. Les frais de livraison sont calculés au paiement."
    ],
    ["Shipping is calculated at checkout.", "Les frais de livraison sont calculés au paiement."],
  ];

  const cookieNeedles = ["Cookie consent", "Manage preferences", "Privacy Policy", "Decline"];

  function replaceText(text) {
    const trimmed = text.trim();
    if (exactReplacements.has(trimmed)) {
      return text.replace(trimmed, exactReplacements.get(trimmed));
    }

    let next = text;
    next = next.replace(
      /We and our partners,[sS]*?Privacy Policy.?/g,
      "Nous utilisons des cookies pour améliorer votre expérience, personnaliser le contenu et réaliser des statistiques. Vous pouvez accepter, refuser ou gérer vos préférences."
    );
    if (next.trim().startsWith("We and our partners")) {
      next = "Nous utilisons des cookies pour améliorer votre expérience, personnaliser le contenu et réaliser des statistiques. Vous pouvez accepter, refuser ou gérer vos préférences.";
    }
    for (const [source, target] of phraseReplacements) {
      next = next.replaceAll(source, target);
    }
    return next;
  }

  function looksLikeCookieBanner(element) {
    const text = element?.textContent || "";
    return cookieNeedles.some((needle) => text.includes(needle));
  }

  function translateElement(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (const node of nodes) {
      const translated = replaceText(node.nodeValue || "");
      if (translated !== node.nodeValue) node.nodeValue = translated;
    }
  }

  function translateCookieBanner() {
    translateElement(document.body);
    for (const element of document.querySelectorAll("*")) {
      if (element.shadowRoot) translateElement(element.shadowRoot);
    }
    document.documentElement.dataset.sokyTextFr = "v4";
    window.sokyStoreTextFrRan = (window.sokyStoreTextFrRan || 0) + 1;
  }

  function start() {
    const delays = [0, 300, 800, 1500, 2500, 4000, 6500, 10000];
    for (const delay of delays) {
      window.setTimeout(translateCookieBanner, delay);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();